// #region Imports
import { defineComponent } from "vue";
import modalMixin from "../../../mixins/modal.mixin";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-messages-question',
    mixins: [modalMixin],
    // #endregion
    // #region Properties
    props: {
        title: {
            type: String,
            required: false,
            default: 'Frage...'
        },
        message: {
            type: String,
            required: false
        },
        successCallback: {
            type: Function,
            required: false
        },
        cancelCallback: {
            type: Function,
            required: false
        },
    },
    // #endregion
    // #region Core
    computed: {
        hasTitle() {
            return !utils.isNullOrEmpty(this.title);
        }
    },
    // #endregion
    // #region Methods
    methods: {
        onSuccess() {
            // #region Callback
            if (this.successCallback) {
                Promise.resolve(this.successCallback())
                    .then(() => this.close(1))
                    .catch((e) => {
                    let tResult = {
                        state: 3,
                        error: utils.getAxiosError(e)
                    };
                    host.notification.showError;
                    this.close(tResult);
                });
            }
            // #endregion
            // #region Close
            else {
                this.close(1);
            }
            // #endregion
        },
        onCancel() {
            // #region Callback
            if (this.cancelCallback) {
                Promise.resolve(this.cancelCallback())
                    .then(() => this.close(2))
                    .catch((e) => {
                    let tResult = {
                        state: 3,
                        error: utils.getAxiosError(e)
                    };
                    this.close(tResult);
                });
            }
            // #endregion
            // #region Close
            else {
                this.close(2);
            }
            // #endregion
        }
    }
    // #endregion
});
// #endregion
